//libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import Accordion from '/react4xp/components/Accordion'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface FaqSectionProps {
    title?: string
    desc?: string
    accordion?: Array<{
        question: string
        answer: string
    }>
}

export default function FaqSection({
    title,
    desc,
    accordion
}: FaqSectionProps) {
    return (
        <Section className='faq-section'>
            <div className='container'>
                <div className='row'>
                    <div className="col-xl-10 offset-xl-1">
                        <div className="row">

                            <div className='col-lg-6 left'>

                                {isNonWhitespaceString(title) && (
                                    <h2 className='h1-hero-big'>
                                        {title}
                                    </h2>  
                                )}

                                {isNonWhitespaceString(desc) && (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: desc }}
                                        suppressHydrationWarning
                                    />
                                )}

                            </div>

                            <div className='col-lg-6 right'>
                                { accordion?.map((item, index) => (
                                    <Accordion
                                        key={index}
                                        question={item.question}
                                        answer={item.answer}
                                    />
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}